module.exports = __webpack_public_path__ + "img/text-icon.96aa7074.png";